module.exports = __webpack_public_path__ + "img/rz-wallpaper.71a03750.jpg";